<template>
  <ConfirmActionDialog
    :model-value="modelValue"
    :title="title"
    description="Confirm you understand that removing this account from the meter exchange journey will:"
    :bullet-points="[
      'Move the account\'s meter exchange ticket to cancellation',
      'Stop the account being sent to Engage through the exchange placement file',
      'Leave the account on the wider Involuntary PAYG journey - this only removes it from the meter exchange step',
    ]"
    confirm-title="Remove from meter exchange journey"
    test-id="remove-from-meter-exchange-journey"
    :loading="loading"
    @update:model-value="$emit('update:modelValue', $event)"
    @confirm="$emit('confirm')"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import ConfirmActionDialog from "./ConfirmActionDialog.vue"

  export default defineComponent({
    components: {
      ConfirmActionDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
      accountNumber: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "confirm"],
    computed: {
      title(): string {
        return `Remove Account ${this.accountNumber} from meter exchange journey`
      },
    },
  })
</script>
